export enum ContainerType {
	CARRIER = "CARRIER",
	REACTIONPLATE = "REACTIONPLATE"
}